<div class="header-page">
  <div class="header-commission-text">
    <mat-icon routerLink="/commissions">chevron_left</mat-icon>
    Commission Details
    @if (externalDeal?.line1Address) {
      - {{ externalDeal.line1Address }}
    }
  </div>
  <div>
    <button mat-button (click)="downloadExternalDealStatement(externalDeal.id)">
      {{
        'deal-details.component.download_statement_link'
          | localise: 'Download statement'
      }}
    </button>
  </div>
</div>

<div class="deal-detail-page">
  @if (loading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  <div class="content-commission">
    @if (externalDeal?.line1Address) {
      <div class="header-cloc">
        <h3>
          {{
            'dashboard-commission-details.component.commission_header'
              | localise: 'Commission'
          }}
        </h3>
        @if (
          externalDeal?.payrollToClocDealLink?.userDealDocuments?.[0];
          as document
        ) {
          @if (loadingFile) {
            <mat-spinner [diameter]="22"></mat-spinner>
          }
          @if (!loadingFile) {
            <p>
              <app-preview-document
                [documentName]="document.s3Key | fileName"
                [fileName]="document.s3Key"
                [documentId]="document.id">
                <a href="javascript:void(0)" class="tongo-link header-button">
                  {{
                    'deal-details.component.view_contract_link'
                      | localise: 'View Contract'
                  }}
                </a>
              </app-preview-document>
            </p>
          }
        }
      </div>
      <ul>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.property_address'
                | localise: 'Property Address'
            }}
          </h4>
          <p>{{ externalDeal | fullAddress }}</p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.commission_amount'
                | localise: 'Your Net Commission'
            }}
          </h4>
          <p>
            {{
              externalDeal?.agentCommissionAmount
                | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'deal-details.component.expected_closing_date'
                | localise: 'Expected Closing Date'
            }}
          </h4>
          <p>
            {{ externalDeal?.closingDate | dateApp: formatDateEnum.MMMDD }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'deal-details.component.selling_agent' | localise: 'Selling Agent'
            }}
          </h4>
          <p>{{ user.fullName }}</p>
        </li>
      </ul>
    }
    @if (externalDeal?.memo) {
      <div class="header-cloc commission-memo">
        <ul>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.memo' | localise: 'Memo'
              }}
            </h4>
            <p>{{ externalDeal.memo }}</p>
          </li>
        </ul>
      </div>
    }
  </div>
  <!-- Advance section -->
  @if (externalDeal?.payrollToClocDealLink?.approvedLimitAmount) {
    <div class="content-commission">
      <div class="header-cloc">
        <h3>
          {{
            'dashboard-commission-details.component.cloc' | localise: 'Advance'
          }}
        </h3>
        @if (transactionList?.list?.length) {
          <div
            (click)="showTransactions = !showTransactions"
            class="header-button">
            <a>Show transactions</a>
            @if (showTransactions) {
              <mat-icon>expand_less</mat-icon>
            } @else {
              <mat-icon>expand_more</mat-icon>
            }
          </div>
        }
      </div>

      <ul [class.m-b-24]="showTransactions">
        <li>
          <h4>
            {{
              'deal-details.component.date_requested'
                | localise: 'Date Requested'
            }}
          </h4>
          <p>
            {{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.approved_limit'
                | localise: 'Approved Limit'
            }}
          </h4>
          <p>
            {{
              externalDeal.payrollToClocDealLink?.approvedLimitAmount
                | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.amount_used'
                | localise: 'Amount Used'
            }}
          </h4>
          <p>
            {{ externalDeal.clocAmountUsed | currencyJs: { showSymbol: true } }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.amount_remaining'
                | localise: 'Amount Remaining'
            }}
          </h4>
          <p>
            {{
              externalDeal.clocAmountRemaining
                | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.total_fees'
                | localise: 'Total Fees'
            }}
          </h4>
          <p>
            {{ externalDeal.clocTotalFees | currencyJs: { showSymbol: true } }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.balance_owed'
                | localise: 'Balance Owed'
            }}
          </h4>
          <p>
            {{
              externalDeal.clocBalanceOwed | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <!-- TODO Next Payment Due-->
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.next_payment_due'
                | localise: 'Next Payment Due'
            }}
          </h4>
          <p>
            {{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
          </p>
        </li>
      </ul>

      @if (showTransactions) {
        <div class="table-wrapper hide-commission">
          <div class="header-deposit">Transactions</div>
          <ng-container
            *ngTemplateOutlet="
              activityFullTable;
              context: {
                withSubTable: true,
                dataSource: transactionList?.list,
                columns: columns,
                subColumns: subColumns,
              }
            "></ng-container>

          <ng-template
            #activityFullTable
            let-withSubTable="withSubTable"
            let-columns="columns"
            let-subColumns="subColumns"
            let-dataSource="dataSource">
            <table
              mat-table
              multiTemplateDataRows
              [class.without-last-border]="!withSubTable"
              class="commission-table"
              [dataSource]="dataSource">
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  Date
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  @if (!app.payment) {
                    @if (app.calculatedEffectiveDate) {
                      {{
                        app.calculatedEffectiveDate
                          | dateApp: formatDateEnum.MMMDD
                      }}
                    } @else if (app.date) {
                      {{ app.date | dateApp: formatDateEnum.MMMDD }}
                    } @else {
                      {{ app.createdAt | dateApp: formatDateEnum.MMMDD }}
                    }
                  } @else {
                    {{ app.groupId }}
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="payoutState">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  Payout State
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  @if (app?.payoutState !== undefined) {
                    {{ transactionPayoutStateNames[app.payoutState] }}
                  } @else {
                    -
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  {{
                    'dashboard-activity.component.amount_header'
                      | localise: 'Amount'
                  }}
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  {{ app.amount | currencyJs: { showSymbol: true } }}
                </td>
              </ng-container>
              <ng-container matColumnDef="unpaidAmount">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  {{
                    'dashboard-activity.component.unpaid_amount_header'
                      | localise: 'Unpaid Amount'
                  }}
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  @if (!app.payment) {
                    {{ app.unpaidAmount | currencyJs: { showSymbol: true } }}
                  } @else {
                    -
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  {{
                    'dashboard-activity.component.type_header'
                      | localise: 'Type'
                  }}
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  @if (!app.payment) {
                    @if (app.activityType === 't') {
                      @if (app.description === 'Instant Transfer') {
                        {{ app.description }}
                      } @else {
                        {{ transactionTypeNames[app.type] }}
                      }
                    } @else {
                      {{
                        'dashboard-activity.component.payout'
                          | localise: 'Payout'
                      }}
                    }
                  } @else {
                    -
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="creditCardNumber">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  {{
                    'dashboard-activity.component.credit_card_header'
                      | localise: 'Credit Card'
                  }}
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  {{ app.creditCard?.cardNumberMask || '-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef class="commission-th">
                  {{
                    'dashboard-activity.component.description_header'
                      | localise: 'Description'
                  }}
                </th>
                <td mat-cell *matCellDef="let app" class="commission-td">
                  {{ app.description }}
                </td>
              </ng-container>
              @if (withSubTable) {
                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="w-10 commission-th">
                    {{
                      'dashboard-activity.component.actions'
                        | localise: 'Actions'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    @if (app.groupId && !app.payment) {
                      <mat-icon
                        class="cursor-pointer"
                        (click)="clickToggleSubTransactions(app)">
                        {{ app.expanded ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    }
                    @if (app.payment && app.createdByUserId) {
                      @if (
                        app.promisedPaymentStatus ===
                          PromisedPaymentStatusEnum.Failed &&
                        !app.resolvePromisedPaymentId
                      ) {
                        <button
                          mat-button
                          class="p-button p-button--inline p-button--secondary p-actions warning-btn"
                          (click)="schedulePayment(app.id)">
                          {{
                            'deal-details.component.resolve'
                              | localise: 'Resolve'
                          }}
                        </button>
                      }
                      @if (
                        app.promisedPaymentStatus !==
                          PromisedPaymentStatusEnum.Processing &&
                        app.promisedPaymentStatus !==
                          PromisedPaymentStatusEnum.Failed
                      ) {
                        <button
                          mat-button
                          class="p-button p-button--inline p-button--secondary p-actions"
                          (click)="cancelPayment(app.id, confirmRemovedTmp)">
                          {{
                            'deal-details.component.cancel' | localise: 'Cancel'
                          }}
                        </button>
                      }
                    }
                  </td>
                </ng-container>
              }

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              @if (withSubTable) {
                <ng-container matColumnDef="_expandedDetail">
                  <td
                    mat-cell
                    *matCellDef="let element"
                    [attr.colspan]="columns.length">
                    <div
                      class="expand-element-detail"
                      [@detailExpand]="
                        element.expanded ? 'expanded' : 'collapsed'
                      ">
                      @if (element.loading) {
                        <div class="spinner-wrapper">
                          <mat-spinner diameter="40"></mat-spinner>
                        </div>
                      }
                      @if (!element.loading && element.subTransactions) {
                        <ng-container
                          *ngTemplateOutlet="
                            activityFullTable;
                            context: {
                              withSubTable: false,
                              dataSource: element.subTransactions,
                              columns: subColumns,
                              subColumns: subColumns,
                            }
                          "></ng-container>
                      }
                    </div>
                  </td>
                </ng-container>
              }
              <tr
                mat-header-row
                *matHeaderRowDef="withSubTable ? columns : subColumns"></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  columns: withSubTable ? columns : subColumns
                "></tr>
              @if (withSubTable) {
                <tr
                  mat-row
                  class="expand-detail-row"
                  *matRowDef="
                    let row;
                    columns: ['_expandedDetail'];
                    when: isExpansionDetailRow
                  "></tr>
              }
            </table>
          </ng-template>
          <div class="alert support">
            <img src="assets/img/icons/info-warning.svg" />
            <div>
              {{
                'deal-details.component.please_contact_support'
                  | localise
                    : 'If you need additional support regarding this deal, please contact support by emailing'
              }}
              <a href="mailto:support@gettongo.com">{{
                'deal-details.component.support_gettongo_com_link'
                  | localise: 'support@gettongo.com'
              }}</a>
              {{
                'deal-details.component.support_calling'
                  | localise: 'or calling (929) 456-5396'
              }}.
            </div>
          </div>
        </div>
      }
    </div>
  }
  <!-- Deposit section -->
  <div class="content-commission">
    <div class="header-cloc">
      <h3>
        {{
          'dashboard-commission-details.component.deposit_header'
            | localise: 'Deposit'
        }}
      </h3>
      @if (
        externalDeal?.transactionStatus ===
          dealTransactionStatusEnum.Initiated ||
        externalDeal?.transactionStatus ===
          dealTransactionStatusEnum.Delivered ||
        externalDeal?.transactionStatus === dealTransactionStatusEnum.Failed
      ) {
        <div (click)="showDetails = !showDetails" class="header-button">
          <a>Show details</a>
          @if (showDetails) {
            <mat-icon>expand_less</mat-icon>
          } @else {
            <mat-icon>expand_more</mat-icon>
          }
        </div>
      }
    </div>

    <ul [class.m-b-24]="showDetails">
      <li>
        <h4>
          {{
            'dashboard-commission-details.component.upload_date'
              | localise: 'Upload Date'
          }}
        </h4>
        <p>{{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDD }}</p>
      </li>
      <li>
        <h4>
          {{
            'dashboard-commission-details.component.total_amount'
              | localise: 'Total Amount'
          }}
        </h4>
        <p>
          {{
            externalDeal?.depositTotalAmount
              | currencyJs: { showSymbol: true, negativeToZero: true }
          }}
        </p>
      </li>
      <li>
        <h4>
          {{
            'dashboard-commission-details.component.source' | localise: 'Source'
          }}
        </h4>
        <p>
          {{
            externalDeal?.isFromCda
              ? externalDeal?.cdaTitleName
              : externalDeal?.brokerApi?.name
          }}
        </p>
      </li>
      @if (externalDeal) {
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.funding_source'
                | localise: 'Funding Source'
            }}
          </h4>
          <p>
            {{ externalDeal.isFromCda ? 'Title' : 'Brokerage' }}
          </p>
        </li>
      }
      <li>
        <h4>
          {{ 'dashboard-deals.component.status_header' | localise: 'Status' }}
        </h4>
        <app-deal-status-with-color
          [dealTransactionStatus]="
            externalDeal?.transactionStatus
          "></app-deal-status-with-color>
      </li>
    </ul>
    @if (
      externalDeal?.transactionStatus ===
      dealTransactionStatusEnum.NeedsConfirmation
    ) {
      <div class="alert-wrapper">
        <div class="need-confirm">
          <mat-icon>info</mat-icon>
          <p class="alert">
            {{
              'dashboard-commission-details.component.deposit_need_confirmation'
                | localise
                  : 'You have a deposit waiting for your approval. You need to confirm your distribution settings before the funds can be sent to your accounts.'
            }}
          </p>
        </div>
        <button
          mat-button
          (click)="confirmDepositDistributions(dealId)"
          class="action-button action-button--primary"
          type="button">
          {{
            'dashboard-commission-details.component.deposit_confirmation_button'
              | localise: 'Confirm Distributions'
          }}
        </button>
      </div>
    }
    @if (
      (externalDeal?.transactionStatus ===
        dealTransactionStatusEnum.Initiated ||
        externalDeal?.transactionStatus ===
          dealTransactionStatusEnum.Delivered ||
        externalDeal?.transactionStatus ===
          dealTransactionStatusEnum.Refunded ||
        externalDeal?.transactionStatus === dealTransactionStatusEnum.Failed) &&
      showDetails
    ) {
      <div class="hide-commission">
        <div class="header-deposit">Deposit breakdown</div>
        <table class="deposit">
          <tr>
            <td>
              {{
                'confirm-deposit-distributions.net_commission'
                  | localise: 'Net Commission'
              }}
            </td>
            <td>
              {{
                externalDeal?.agentCommissionAmount
                  | currencyJs: { showSymbol: true }
              }}
            </td>
          </tr>
          <tr>
            <td>
              {{
                'dashboard-commission-details.component.deposit_repayment'
                  | localise: 'Advance Repayment'
              }}
            </td>
            <td>
              {{
                externalDeal.depositRepayment | currencyJs: { showSymbol: true }
              }}
            </td>
          </tr>
          <tr>
            <td>
              {{
                'dashboard-commission-details.component.total_deposit'
                  | localise: 'Total to Deposit'
              }}
            </td>
            <td>
              @if (externalDeal.depositBreakdown.value > 0) {
                {{
                  externalDeal.depositBreakdown
                    | currencyJs: { showSymbol: true }
                }}
              }
            </td>
          </tr>
        </table>

        <mat-divider></mat-divider>

        @if (agentCommissionTransactions.length > 0) {
          <table
            mat-table
            (matSortChange)="setSort($event.active, $event.direction)"
            [dataSource]="agentCommissionTransactions"
            class="commission-table"
            matSort>
            <ng-container matColumnDef="accountNickname">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'commission-details.component.deposit_breakdown_account_nickname'
                    | localise: 'Account Nickname'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                {{
                  app?.bankAccount
                    ? app?.bankAccount?.accountNickname
                    : app?.cardNickname
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="paymentDate">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'commission-details.component.deposit_breakdown_date_delivered'
                    | localise: 'Date Send'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                @if (app.status === TransactionStatusEnum.Failed) {
                } @else {
                  {{ app?.effectiveDate | dateApp: formatDateEnum.MMMDD }}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="account">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'commission-details.component.deposit_breakdown_account'
                    | localise: 'Account'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                @if (app.type === TransactionTypeEnum.PaymentFromPartner) {
                  <div>
                    {{
                      'dashboard-commission-details.component.repayment_debts_tongo'
                        | localise: 'Repayment of debts to Tongo'
                    }}
                  </div>
                } @else {
                  {{ app | bankInfo }}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="distributionAmount">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'dashboard-deals.component.deposit_breakdown_distribution_amount_percent'
                    | localise: 'Distribution Amount'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                {{ app.depositPercent | currencyJs: { showSymbol: false } }}%
              </td>
            </ng-container>
            <ng-container matColumnDef="depositAmount">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'dashboard-deals.component.deposit_breakdown_amount'
                    | localise: 'Deposit Amount'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                {{ app?.amount | currencyJs: { showSymbol: true } }}
              </td>
            </ng-container>
            <ng-container matColumnDef="depositStatus">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="commission-th">
                {{
                  'dashboard-deals.component.deposit_status'
                    | localise: 'Deposit Status'
                }}
              </th>
              <td mat-cell *matCellDef="let app" class="commission-td">
                <app-deal-status-with-color
                  [dealTransactionStatus]="
                    app.status | convertToDealTransactionStatus
                  "></app-deal-status-with-color>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsPayroll"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsPayroll"></tr>
          </table>
        }
      </div>
    }
  </div>

  <!-- Deposit Breakdown section -->
</div>

<ng-template #confirmRemovedTmp>
  <h1 mat-dialog-title>
    {{
      'dashboard-banks.component.cancel_scheduled_payment'
        | localise: 'Cancel scheduled payment?'
    }}
  </h1>
  <div mat-dialog-content>
    {{
      'dashboard-activity.component.confirm_cancel_payment'
        | localise
          : 'Please confirm that you would like to cancel this scheduled payment.'
    }}
  </div>

  <div mat-dialog-actions>
    <button mat-button type="button" mat-dialog-close class="m-r-a wide-btn">
      {{ 'dashboard-activity.component.close' | localise: 'Close' }}
    </button>
    <button
      mat-button
      type="submit"
      [mat-dialog-close]="true"
      class="dialog-button--primary">
      {{
        'dashboard-activity.component.yes_cancel_payment'
          | localise: 'Yes, Cancel Payment'
      }}
    </button>
  </div>
</ng-template>
